var _path;
import * as React from "react";
function SvgArrowCircleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36c-8.839 0-16-7.161-16-16S11.161 4 20 4s16 7.161 16 16-7.161 16-16 16zm1.864-9.265l-4.87-4.67h11.78c.858 0 1.549-.69 1.549-1.549v-1.032c0-.858-.69-1.549-1.549-1.549h-11.78l4.87-4.67c.626-.6.64-1.6.026-2.213l-.71-.704a1.542 1.542 0 00-2.186 0l-8.562 8.555a1.542 1.542 0 000 2.187l8.562 8.568a1.542 1.542 0 002.187 0l.71-.703c.612-.62.6-1.62-.026-2.22z"
  })));
}
export default SvgArrowCircleLeft;